<button
  mat-button
  [attr.blurOption]="BlurOption.PREVENT_BLUR"
  [disabled]="!enabled"
  [class.active]="isReordering"
  [matTooltip]="toolbarItem.tooltipText"
  matTooltipPosition="below"
  [matTooltipShowDelay]="tooltipDelay"
  (click)="reorderClauses()"
  [attr.aria-label]="toolbarItem.ariaLabel"
>
  <mat-icon *ngFor="let icon of toolbarItem.icons">{{ icon }}</mat-icon>
  <cars-alt-accessibility
    [altProperties]="altProperties"
    [richText]="true"
    (onSelect)="reorderClauses()"
  ></cars-alt-accessibility>
</button>
